<script setup lang="ts">
const props = defineProps<{
  userRatingCount: number
  reviewsUri: string
  rating: number
}>()

const { t } = useI18n()

const givenRatings = computed(() => props.userRatingCount)

const reviewsUri = computed(() => props.reviewsUri)

const totalRatingFloor = computed(() => Math.floor(props.rating))
const totalRatingCeil = computed(() => Math.ceil(props.rating))

const partialRatingPercentage = computed(() => props.rating > totalRatingFloor.value ? (props.rating - totalRatingFloor.value) * 100 : 0)
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-1.5">
      <span class="text-sm font-medium text-gray-800">
        {{ rating }}
      </span>
      <div class="flex items-center gap-0.5">
        <GoogleRatingStar
          v-for="i in 5"
          :key="i"
          :colored="i <= totalRatingFloor"
          :partially-colored="i > totalRatingFloor && i <= totalRatingCeil"
          :partially-colored-percentage="partialRatingPercentage"
        />
      </div>
      <span class="text-xs text-gray-600">
        ({{ givenRatings }})
      </span>
    </div>

    <div class="flex items-center gap-2.5">
      <GoogleLogo class="size-5" />
      <i18n-t
        keypath="googleReviewBadge.onGoogleReviews"
        tag="span"
        class="text-xs text-gray-600"
      >
        <template #link>
          <NuxtLink
            :to="reviewsUri"
            target="_blank"
            class="font-medium underline hover:text-gray-800 active:text-gray-600"
            external
          >
            {{ t('googleReviewBadge.reviews') }}
          </NuxtLink>
        </template>
      </i18n-t>
    </div>
  </div>
</template>
